import { render, staticRenderFns } from "./BlogGridSidebarPage.vue?vue&type=template&id=c090c07e&"
import script from "./BlogGridSidebarPage.vue?vue&type=script&lang=js&"
export * from "./BlogGridSidebarPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports